module.exports = __webpack_public_path__ + "img/beer_id-11.a0d66f59.png";